import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { AppConfigService } from "src/app/services/app-config.service";
import { AssetsPath } from "src/static-assets/assets-path";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { UserService } from "src/app/shared/services/user.service";
import { Subject, takeUntil } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-mmp-main-header",
  templateUrl: "./mmp-main-header.component.html",
  styleUrls: ["./mmp-main-header.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class MmpMainHeaderComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  public assetsPath = AssetsPath;
  logoPath: string = "";
  isMenuOpen: boolean = false;
  profileImagePath: string = "";
  userName: string = "";
  userDesignation: string = "";
  hasNotification: boolean = true;

  constructor(
    private readonly envService: AppConfigService,
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private readonly userService: UserService,
    private readonly snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.logoPath =
      this.envService.assetBaseUrl + this.assetsPath.brandingAssetsStudent.logo;
    this.profileImagePath =
      this.envService.assetBaseUrl +
      this.assetsPath.brandingAssetsStudent.profile_image;

    const currentUser = this.userService.getUser();
    if (currentUser) {
      this.userName = currentUser.name;
      this.userDesignation = currentUser.role;
    } else {
      this.oktaAuth.getUser().then((user) => {
        this.userName = user.name;
        user.dnumber = this.getDnumberFromPreferredUsername(
          user.preferred_username,
        );
        this.getUserDetails(user);
        this.userService.setUser(user);
      });
    }
  }

  onMenuClick(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  private getDnumberFromPreferredUsername(preferred_username: string): string {
    if (typeof preferred_username === "string") {
      const [dnumber] = preferred_username.split("@");
      return dnumber ?? "";
    }
    return "";
  }

  getUserDetails(user: any): any {
    this.userService
      .fetchUserDetails(user.dnumber)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          user.role = data?.Advisor ? "Advisor" : "Admin";
          this.userDesignation = user.role;
          this.userService.setUser(user);
        },
        (error) => {
          if (this.envService.showConsoleLogs) {
            console.error("Error fetching user details:", error);
          }
          this.showToast(
            "toast-error",
            "Error fetching user details. Please refresh the page.",
          );
        },
      );
  }

  showToast(type: string, message: string) {
    this.snackBar.open(message, "x", {
      duration: 3000,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [type],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
